import React from 'react'
import styles from './TermsAndConditions.module.css'
const TermsAndConditions = () => {
  return (
    <div className={styles.parentContainer}>
       <div className={styles.mainContainer}>
      <h1 className={styles.heading}>Terms & Conditions</h1>
      <h3>
        Terms and Conditions for Cricway - Indian Cricket Live Score and Line
        Rate Website
      </h3>
      <p>
        Welcome to Cricway. By accessing and using the website, you
        agree to be bound by the following terms and conditions:
      </p>

      <h3>Use of the Website</h3>
      <p>
        The Website is designed to provide live cricket scores, updates, and line
        rates for cricket matches in India. You may use the website for personal and
        non-commercial purposes only. You must not use the website for any unlawful
        purpose or in any way that may damage or disrupt the website.
      </p>

      <h3>Wheel of Fortune</h3>
      <p>
        Welcome to the Wheel of Fortune Daily website ("website") and our exciting gifts
        program! We want to make sure you have a clear understanding of our
        policies regarding gifts and their associated timelines. Please read
        this policy carefully to participate in the program effectively.
      </p>

      <h3>Gift Distribution</h3>
      <p>
        Eligibility: All registered website users are eligible to participate in the
        Wheel of Fortune gifts program.
      </p>
      <p>
        Gift Types: Our gifts may include virtual items, discounts, vouchers, or
        physical products, depending on availability and your location.
      </p>
      <p>
        Frequency: The availability of the Wheel of Fortune and gift
        distribution frequency may vary. Check the website for updates and
        notifications.
      </p>

      <h3>Timelines and Redemption</h3>
      <p>
        Gift Availability: Gifts won through the Wheel of Fortune will be
        available in your website account shortly after winning.
      </p>
      <p>
        Expiry Dates: Gifts may have expiry dates, and it's essential to use
        them within the specified timeline. Expired gifts may not be reissued.
      </p>
      <p>
        Redemption Process: Follow the instructions provided in the website to
        redeem your gifts. The redemption process may vary depending on the type
        of gift.
      </p>

      <h3>Gift Policies</h3>
      <p>
        Non-Transferable: Gifts are non-transferable and may not be exchanged
        for cash or transferred to other users.
      </p>
      <p>
        Fair Usage: We reserve the right to monitor and prevent abuse or unfair
        usage of the Wheel of Fortune and gifts program.
      </p>
      <p>
        Cancellation: We may cancel or modify the program, gifts, or their
        policies at any time without prior notice.
      </p>

      <h3>User Accounts</h3>
      <p>
        To access certain features of the website, you may be required to create an
        account. You agree to provide accurate and complete information when
        creating your account and to keep your login credentials confidential.
        You are responsible for all activities that occur under your account.
      </p>

      <h3>Intellectual Property</h3>
      <p>
        The website and all content contained therein, including but not limited to
        text, graphics, logos, images, and software, are the property of Cricway
        or its licensors and are protected by Indian and international copyright
        and trademark laws. You may not reproduce, modify, distribute, or
        display any part of the website without the prior written consent of
        Cricway.
      </p>

      <h3>Disclaimer of Warranties</h3>
      <p>
        The website is provided on an "as is" and "as available" basis, without any
        warranties of any kind, express or implied. Cricway does not guarantee
        the accuracy, completeness, or timeliness of the information provided by
        the website. Cricway disclaims all warranties, including but not limited to
        warranties of merchantability, fitness for a particular purpose, and
        non-infringement.
      </p>

      <h3>Limitation of Liability</h3>
      <p>
        Cricway shall not be liable for any damages of any kind arising from the
        use of the website, including but not limited to direct, indirect,
        incidental, punitive, and consequential damages. In no event shall
        Cricway's liability exceed the amount paid by you for accessing the website.
      </p>

      <h3>Indemnification</h3>
      <p>
        You agree to indemnify and hold Cricway and its officers, directors,
        employees, and agents harmless from any claims, liabilities, damages,
        and expenses (including reasonable attorneys' fees) arising from your
        use of the website or your breach of these terms and conditions.
      </p>

      <h3>Modification of Terms and Conditions</h3>
      <p>
        Cricway reserves the right to modify these terms and conditions at any
        time. Your continued use of the website following any such modification
        constitutes your acceptance of the modified terms and conditions.
      </p>

      <h3>Governing Law and Jurisdiction</h3>
      <p>
        These terms and conditions shall be governed by and construed in
        accordance with the laws of India. Any dispute arising out of or in
        connection with these terms and conditions shall be subject to the
        exclusive jurisdiction of the courts of India.
      </p>

      <h3>Entire Agreement</h3>
      <p>
        These terms and conditions constitute the entire agreement between you
        and Cricway regarding the use of the website and supersede all prior or
        contemporaneous communications and proposals, whether oral or written,
        between you and Cricway.
      </p>
      <p>
        If you have any questions or concerns about these terms and conditions,
        please contact us at support@cricway.live
      </p>
    </div>
    </div>
  )
}

export default TermsAndConditions
